import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ConfirmModal from './Confirm';
import ClickToCopy from 'components/tooltip/click-to-copy';
import Icon from 'components/icon';
import { Field } from 'components/form';
import { nl2br } from 'utils';

export default class ConfirmDeleteModal extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    titleMessage: PropTypes.any,
    loadingTitle: PropTypes.string,
    confirmInput: PropTypes.object,
    action: PropTypes.string,
    actionType: PropTypes.string,
    message: PropTypes.any,
    extraActions: PropTypes.array,
    width: PropTypes.number,
    confirmError: PropTypes.string,

    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
  };

  state = {
    confirmError: null,
  };

  componentDidMount() {
    setTimeout(() => {
      if (this.refs.confirmValue) {
        this.refs.confirmValue.focus();
      }
    }, 500);
  }

  isConfirmInputValid() {
    const { confirmInput, confirmError } = this.props;

    if (
      String(this.refs.confirmValue?.value()).toLowerCase().trim() ===
      String(confirmInput.value).toLowerCase().trim()
    ) {
      return true;
    }

    this.setState({
      confirmError:
        confirmError ||
        `Please enter "${confirmInput.value}" to confirm deletion`,
    });
    return false;
  }

  onConfirmInput = (_event) => {
    if (this.isConfirmInputValid()) {
      return this.props.onConfirm();
    }
    return false;
  };

  // Extra actions with `onConfirm` require the confirm input as well
  getExtraActions() {
    const { confirmInput, extraActions } = this.props;

    if (!confirmInput) {
      return extraActions;
    }

    return extraActions?.map((act) =>
      act?.onConfirm
        ? {
            ...act,
            onConfirm: () =>
              this.isConfirmInputValid() ? act.onConfirm() : false,
          }
        : act,
    );
  }

  render() {
    const {
      title,
      titleMessage,
      loadingTitle,
      onConfirm,
      onCancel,
      message = null,
      confirmInput = null,
      action = 'Delete',
      actionType = 'danger',
      width,
    } = this.props;

    return (
      <ConfirmModal
        title={titleMessage || `Delete ${title}`}
        message={
          <Fragment>
            {typeof message === 'string' ? (
              <p>{nl2br(message)}</p>
            ) : message ? (
              message
            ) : (
              <p>
                Are you sure you want to delete <b>{title}</b>?{' '}
                {!confirmInput && "This action can't be undone."}
              </p>
            )}
            {confirmInput && (
              <Fragment>
                <p>
                  {confirmInput.description}:&nbsp;
                  <span className="nowrap">
                    <ClickToCopy value={confirmInput.value}>
                      {confirmInput.value}
                      <Icon fa="copy" />
                    </ClickToCopy>
                  </span>
                </p>
                <Field
                  ref="confirmValue"
                  placeholder={confirmInput.value}
                  readonly={true}
                  error={this.state.confirmError}
                />
              </Fragment>
            )}
          </Fragment>
        }
        action={action}
        actionType={actionType}
        onConfirm={confirmInput ? this.onConfirmInput : onConfirm}
        onCancel={onCancel}
        extraActions={this.getExtraActions()}
        loadingTitle={loadingTitle}
        width={width}
      />
    );
  }
}
